import * as React from "react";
import { Helmet } from "react-helmet";
//import { mobile, mobile, isLaptop, isBigScreen, isDesktop, isTabletDevice } from './MediaQueries'
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import { logo } from '../img';
import Footer from './Footer';
import { connect } from "react-redux";
import { MailOutlined, LoginOutlined, LockOutlined, BarChartOutlined, IdcardOutlined, FileDoneOutlined, AuditOutlined, CloudSyncOutlined,HddOutlined } from '@ant-design/icons/lib';
import { Button, Input, Form, Row, Col, Card, message, Modal} from 'antd';
import { postQuery } from "../utils";
const { Item } = Form;

// At runtime, Redux will merge together...
type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested
    //& RouteComponentProps<{ startDateIndex: string }>; // ... plus incoming routing parameters

class Welcome extends React.Component<AuthProps>
{
    public state = {
        confirmLoading: false, returnUrl: '',
        user: { email: '', password: '' }, mobile: false, ipad: false, laptop: false, screenWidth : 0, loginSuccess: false, year: new Date().getFullYear(), accReq: { message: '', email: '' },
            visible: false };
    
    componentDidMount() 
    {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));

        var loginForm = document.getElementById("login-form");
        if (loginForm && loginForm !== null)
        {
            loginForm.addEventListener("keyup", function (event)
            {
                if (event.keyCode === 13)
                {
                    event.preventDefault();
                    var btn = document.getElementById("login-button");
                    if (btn !== null)
                    {
                        btn.click();
                    }
                }
            });
        }      
        
    }

    componentWillUnmount()
    {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this))
    }

    updateWindowDimensions()
    {
        let mobile = window.innerWidth <= 768;
        let ipad = window.innerWidth >= 768 && window.innerWidth < 1200;
        let laptop = window.innerWidth > 1200;
        this.setState({ screenWidth: window.innerWidth, mobile, ipad, laptop });
       
    }

    emailChange(e: React.ChangeEvent<HTMLInputElement>)
    {
        var user = this.state.user;
        user.email = e.target.value;
        this.setState({ user });
    }

    passwordChange(e: React.ChangeEvent<HTMLInputElement>)
    {
        var user = this.state.user;
        user.password = e.target.value;
        this.setState({ user });
    }

    signIn(e: React.MouseEvent<HTMLElement, MouseEvent>) 
    {
        if (!this.state.user.email)
        {
            message.error("Please provide User's Email");
            return;
        }
        if (!this.state.user.password)
        {
            message.error("Please provide User's Password");
            return;
        }
        this.props.login(this.state.user);                
    }

    textChange(feature: string, e: any)
    {
        let accReq = this.state.accReq;
        accReq[feature] = e.target.value;
        this.setState({ accReq });
    }

    exit()
    {
        this.setState({
            visible: false
        });
    }

    ////@ts-ignore
    async sendRequest()
    {
        let el = this;
        if (!el.state.accReq.email)
        {
            message.error("Please provide youe Email");
            return;
        }
        if (!el.state.accReq.message)
        {
            message.error("Please provide a Message");
            return;
        }        

        let url = '/api/Account/requestAccount';
        
        this.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(el.state.accReq));
        this.setState({ confirmLoading: false });
        if (res.code > 0)
        {
            message.error("Your request has been sent.");
            this.setState({ visible: false });
            message.success(res.message);
        }
        else
        {
            message.error(res.message);
        }
    }

    prepReq() {
        this.setState({ accReq: { message: '', email: '' }, visible: true });
    }

    public render()
    {
        const { confirmLoading, user, accReq, visible, mobile, ipad, laptop, screenWidth } = this.state;
                
        return <div id="loginPage" className="main-bg">

            <Helmet>
                <title>CDR | Welcome</title>
            </Helmet>                       
            <h3  className="title">
                CDR
            </h3>	       
            <div className="sub-main-w3">
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={16} className="kitmWA">
                        <Col span={24} style={{ padding: '40px' }}>
                            <h1>
                                The Clinical Data Repository (CDR) is a centralised true representation of data streaming from 150+ Health facilities across Nigeria
                            </h1> 
                            <Col span={8} style={{ marginTop: '20px', paddingRight: '40px', marginBottom: '25px' }}>
                                <Button onClick={() => this.prepReq()} className="login-button" type="primary" size="large" style={{ paddingRight: '15px', paddingLeft: '15px', width: '50% !important', float: 'left' }}>
                                    Request an Account
                                </Button>
                            </Col>
                        </Col>                        
                    </Col>
                </Row>                            
            </div>  
            <Row style={{ background: '#fff', paddingBottom: '32px', marginTop: '0px' }}>
                <Col className={ipad ? "ant-col-24" : "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-16 ant-col-lg-16 ant-col-xl-16"}>
                    <Row className='lk' style={{ paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }} gutter={2}>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ? "lk-icon-pos-mobile db-h3-i" : "lk-icon-pos-others db-h3-i"}>
                                        <HddOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}> See the true picture of data in a clinic without going there</p>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ? "lk-icon-pos-mobile db-h3-i" : "lk-icon-pos-others db-h3-i"}>
                                        <CloudSyncOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}> Perform targeted DQA/R From anywhere</p>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ?  "lk-icon-pos-mobile db-h3-i" :  "lk-icon-pos-others db-h3-i"}>
                                        <AuditOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}> Audit client trackers' performances</p>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ? "lk-icon-pos-mobile db-h3-i" : "lk-icon-pos-others db-h3-i"}>
                                        <FileDoneOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}> Validate the efficiencies of data mop ups/interventions</p>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ? "lk-icon-pos-mobile db-h3-i" : "lk-icon-pos-others db-h3-i"}>
                                        <IdcardOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}> Fish out irregularities via patient level Deep-dive</p>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                            <Card className="ant-card-body">
                                <div className="custom-image">
                                    <h3 className={mobile ? "lk-icon-pos-mobile db-h3-i" : "lk-icon-pos-others db-h3-i"}>
                                        <BarChartOutlined className="db-i" />
                                    </h3>
                                </div>
                                <div className="custom-card">
                                    <p className={mobile ? 'h3-mobile' : 'h3-other-screen'}>Easy access to robust Line lists and MER analytics</p>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row className='lk' style={{ paddingLeft: '40px', paddingRight: '40px', paddingTop: '12px' }} gutter={2}>
                        <div className="md-wrapper">
                            <Modal className="modal-width-500"
                                visible={visible}
                                title="Request an Account"
                                maskClosable={false}
                                onCancel={() => this.exit()}
                                footer={[
                                    <Button id="submit-btn" className="login-button" style={{ width: '30%' }} loading={confirmLoading} key="submit" type="primary" size="large" onClick={() => this.sendRequest()}>
                                        <MailOutlined /> <span id="buttonText">Send</span>
                                    </Button>
                                ]}>

                                <Form id="users">
                                    <div className='ant-row'>
                                        <div className='ant-col-24 padding-md lg_op'>
                                            <Item>
                                                <Row>
                                                    <Col span={24} style={{ paddingRight: '5px' }}>
                                                        <input style={{ borderRadius: "0 !important" }} onChange={(e) => this.textChange('email', e)} name="email" type="email" className="ant-input ant-input-lg input-no-border" placeholder="Please enter your Email *" value={accReq.email} />
                                                    </Col>
                                                </Row>
                                            </Item>
                                            <Item>
                                                <Row>
                                                    <Col span={24} style={{ paddingRight: '5px' }}>
                                                        <textarea style={{ borderRadius: "0 !important", height: '148px' }} onChange={(e) => this.textChange('message', e)} name="message" className="ant-input ant-input-lg input-no-border" placeholder="Message" value={accReq.message} />
                                                    </Col>
                                                </Row>
                                            </Item>
                                        </div>
                                    </div>
                                </Form>
                            </Modal>
                        </div>
                    </Row>
                </Col>
                <Col className={ipad ? "ant-col-24" :  "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-8 ant-col-lg-8 ant-col-xl-8"}>
                    <div className={"bg-content-w3pvt " + (laptop ? "larger-screen" : ipad ? "medium-screen" : "mobile-screen")}>
                        <div className="top-content-style">
                            <img className="logo" src={logo} alt="" />
                            <div style={{ paddingTop: '15px', fontSize: '20px', color: '#fff' }}>
                                <span>Clinical Data Repository</span>
                            </div>
                        </div>
                        <div className="access-div">
                            <p className="legend">Login Here<span className="fa fa-hand-o-down"></span></p>
                            <Form id="login-form">
                                <Row>
                                    <Item>
                                        <Col span={24}>
                                            <Input suffix={<MailOutlined />} onChange={(e) => this.emailChange(e)} className="ant-input-lg input-no-border" type="email" placeholder="Email *" name="email" required value={user.email} />
                                        </Col>
                                    </Item>
                                    <Item>
                                        <Col span={24}>
                                            <Input.Password suffix={<LockOutlined />} onChange={(e) => this.passwordChange(e)} className="ant-input-lg input-no-border" type="password" placeholder="Password *" name="password" required value={user.password} />
                                        </Col>
                                    </Item>
                                    <Item style={{ marginBottom: '2px !important' }} className="lgn-div">
                                        <Col className="logY" span={24} style={{ textAlign: 'center' }}>
                                            <Button className="login-button lgn-bttn" id="login-button" loading={confirmLoading} key="submit" type="primary" size="large" onClick={(e) => this.signIn(e)}>
                                                <LoginOutlined />
                                                {this.props.isLoading ? ' Please wait...' : ''}
                                            </Button>
                                        </Col>
                                    </Item>
                                </Row>
                            </Form>
                        </div>

                    </div>
                </Col>
            </Row>  
        </div>
            
    }
}


export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Welcome as any);


